import { Route } from "react-router-dom";
import React from 'react'
import { ListadoAuditoriasProgramadasScreen } from "./ConteosAuditoria/ListadoAuditoriasProgramadasScreen";
import { RealizarConteoScreen } from "./ConteosAuditoria/RealizarConteoScreen";
import { ListadoAuditoria } from "./ListadoAuditoria";
import ProgramarInventarioMainScreen from "./ProgramarInventario/ProgramarInventarioMainScreen";
import JustificacionMainScreen from "./Justificaciones/JustificacionesMainScreen";
import JustificacionesListadoScreen from "./Justificaciones/JustificacionesListadoScreen";


export const RutasAuditoria = () => {
    return (
        <div className="main-container">
            <Route
                path="/Auditoria/Main"
                component={() => <ListadoAuditoria />}
            />

            <Route
                path="/Auditoria/ListadoAuditorias"
                component={() => <ListadoAuditoriasProgramadasScreen />}
            />

            <Route
                path="/Auditoria/RealizarConteo"
                component={() => <RealizarConteoScreen />}
            />

            <Route
                path="/Auditoria/ProgramarInventario"
                component={() => <ProgramarInventarioMainScreen />}
            />

            <Route
                path="/Auditoria/Justificaciones"
                component={() => <JustificacionesListadoScreen />}
            />

            <Route
                path="/Auditoria/JustificarFolio"
                component={() => <JustificacionMainScreen />}
            />

        </div>
    );
};
